// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z1zpF","question":"styles_question__3xgmq","inputVisibleButton":"styles_inputVisibleButton__SPSMI","note":"styles_note__2uqm0"};